(ns ycweb.app.website.voucher.design
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.voucher.common :as common]
   [ycweb.app.website.website :as website]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc cover-option < rum/reactive [app-atom {:keys [cover-id title public-id method]}]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-id (cmn/curact process-atom :voucher-id)]
    [:a.visual-option
     (urlstate/href-props app-atom "gift-vouchers" (if voucher-id "editvoucher" "createvoucher")
       (u/maybe assoc
         {:method method :coverid cover-id}
         :voucherid voucher-id))
     [:figure.visual-option__content
      (web-common/lazy-image app-atom
        public-id
        {:class ["yc-simple-image  yc-simple-image--full"]}
        {:w 320
         :h 220
         :dpr 2
         :c "lpad"
         :q "auto"
         :alt title})
      [:span.visual-option__icon
       [:i {:class (u/bem :icon [:block :default :is-light :check])}]]]]))

(rum/defc sub-category < rum/reactive [app-atom id description]
  (let [process-atom (cmn/process-cursor app-atom)
        method (cmn/curact process-atom [:voucher :voucher/method])
        voucher-id (cmn/curact process-atom [:voucher :voucher/voucher-id])]
    [:li.button-bar__sub-menu-item
     [:a.button-bar__sub-menu-link
      (urlstate/href-props app-atom "gift-vouchers" "choosecover"
        (u/maybe assoc
          {:method method
           :categoryid id}
          :voucherid voucher-id))
      description]]))

(rum/defc category < rum/reactive [app-atom id description sub-categories]
  (let [process-atom (cmn/process-cursor app-atom)
        method (cmn/curact process-atom [:voucher :voucher/method])
        category-id (cmn/curact process-atom :category-id)
        voucher-id (cmn/curact process-atom [:voucher :voucher/voucher-id])]

    [:li
     {:class
      (u/bem :button-bar__item
        (when
          (or
            (= category-id id)
            (contains? (set (map :sub-category/id sub-categories)) category-id))
          [:active]))}
     [:a.button-bar__link
      (cond
        (not sub-categories)
        (urlstate/href-props app-atom "gift-vouchers" "choosecover"
          (u/maybe assoc
            {:method method
             :categoryid id}
            :voucherid voucher-id))

        :else
        {:href "#"
         :on-click
         (fn [e]
           (.preventDefault e))})
      description
      (when sub-categories
        (list
          " "
          [:i {:class (u/bem :icon [:chevron-down :is-dark :default :inline])}]))]
     (when sub-categories
       [:ul.button-bar__sub-menu
        (map
          (fn [{:sub-category/keys [id description]}]
            (rum/with-key
              (sub-category app-atom id description)
              id))
          sub-categories)])]))

(rum/defc covers-view < rum/reactive [app-atom id title image]
  (let [process-atom (cmn/process-cursor app-atom)
        method (cmn/curact process-atom [:voucher :voucher/method])]
    [:article
     {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-3 :l-1-4])}
     [:div.flex-grid-content
      (cover-option app-atom
        {:cover-id id
         :title title
         :public-id (:doc/public-id image)
         :method method})]]))

(rum/defc nav-button < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        method (cmn/curact process-atom [:voucher :voucher/method])
        voucher-id (cmn/curact process-atom :voucher-id)
        category-id (cmn/curact process-atom :category-id)
        categories (cmn/curact process-atom :categories)
        no-category? (or (nil? category-id) (zero? category-id))]
    [:nav.button-bar-wrapper.group
     [:div.button-bar-prefix
      [:span.button-bar__label
       "Filter:"]]
     [:ul.button-bar.group.l_tinynav1
      {:id :voucher-cover-list}
      [:li
       {:class (u/bem :button-bar__item (when no-category? [:active]))}
       [:a.button-bar__link
        (urlstate/href-props app-atom "gift-vouchers" "choosecover"
          (u/maybe assoc
            {:method method}
            :voucherid voucher-id))
        "All"]]
      (map
        (fn [{:category/keys [id description sub-categories]}]
          (rum/with-key
            (category app-atom id description sub-categories)
            id))
        categories)]

     [:div.form.button-bar-select
      [:div.yc-select-wrapper
       [:select#tinynav1.tinynav.select
        {:on-change
         (fn [e]
           (let [catid (u/presence (.. e -target -value))]
             (urlstate/redirect app-atom "gift-vouchers" "choosecover"
               (u/maybe assoc
                 {:method method}
                 :categoryid (u/presence catid)))))
         :value (or (u/presence category-id) "")}
        [:option {:value ""} "All"]
        (map
          (fn [{:category/keys [id description sub-categories] :as c}]
            (concat
              [[:option
                (u/maybe assoc {:value id} :disabled (not-empty sub-categories))
                description]]
              (map
                (fn [sub-cat]
                  [:option {:value (:sub-category/id sub-cat)} "- " (:sub-category/description sub-cat)])
                sub-categories)))
          categories)]]]]))

(rum/defc covers-grid < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        pagination-settings (rum/cursor process-atom :pagination-settings)
        {:keys [pages]} (rum/react pagination-settings)
        category-id (cmn/curact process-atom :category-id)
        all-covers (cmn/curact process-atom :covers)
        no-category? (or (nil? category-id) (zero? category-id))

        covers
        (cond
          no-category?
          all-covers

          :else
          (sort-by (juxt :cover/categoryrank :cover/id)
            (filter
              #(contains? (set (str/split (:cover/categoryids %) #",")) (str category-id))
              all-covers)))

        paginated-covers
        (->>
          covers
          (drop (* (- (:page pages 1) 1) (:pagesize pages 24)))
          (take (:pagesize pages 24)))]
    [:div
     {:class (u/bem :yc-section [:standard])}
     [:div.flex-grid-group
      (map
        (fn [{:cover/keys [id title]
              :ent/keys [image]}]
          (rum/with-key
            (covers-view app-atom id title image)
            id))
        paginated-covers)
      (toaster/loading-overlay app-atom :web.gift-vouchers/choosecover)]]))

(rum/defc voucher-design < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        pagination-settings (rum/cursor process-atom :pagination-settings)
        {:keys [pages]} (rum/react pagination-settings)
        category-id (cmn/curact process-atom :category-id)
        all-covers (cmn/curact process-atom :covers)
        no-category? (or (nil? category-id) (zero? category-id))

        covers
        (cond
          no-category?
          all-covers

          :else
          (sort-by (juxt :cover/categoryrank :cover/id)
            (filter
              #(contains? (set (str/split (:cover/categoryids %) #",")) (str category-id))
              all-covers)))

        pagecount (u/ceil (/ (count covers) 24))]

    (when (> (or (:page pages) 0) pagecount)
      (swap! pagination-settings assoc-in [:pages :page] 1))

    [:div
     {:class (u/bem :yc-page-content [:standard])}

     (common/process-bar app-atom
       {:title "Choose your voucher"
        :step 1
        :action "choosecover"})
     (nav-button app-atom)
     (covers-grid app-atom)

     [:div
      {:class (u/bem :yc-section [:large])}
      [:nav.pagination-wrapper
       (web-common/pagination-control app-atom (rum/cursor pagination-settings :pages) pagecount {:scroll-to "voucher-cover-list"})]]]))

(defmethod flow/render-screen :web.gift-vouchers/choosecover [app-atom _]
  (website/screen-wrapper app-atom
    (voucher-design app-atom)
    {}))

(defmethod comms/receive :web.gift-vouchers/list-covers [app-atom e]
  (toaster/close-overlay app-atom :web.gift-vouchers/choosecover)
  (swap! (cmn/process-cursor app-atom) assoc
    :covers (:covers e)
    :categories (:categories e)))

(defmethod t/transition-open :web.gift-vouchers/choosecover [app-atom _ params]
  (let [process-name (cmn/process-name app-atom)]
    (swap! app-atom update process-name
      (fn [process]
        (->
          process
          (assoc
            :category-id (when (:categoryid params) (trf/tonumber (:categoryid params))))
          (update :voucher
            (fn [voucher]
              (assoc voucher
                :voucher/method (:method params)
                :voucher/voucher-id
                (when (:voucherid params)
                  (:voucherid params))))))))

    (toaster/open-overlay app-atom :web.gift-vouchers/choosecover)
    (comms/ajax-get :web.gift-vouchers/list-covers {})))